import script from "./StudentInfoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentInfoPanel.vue?vue&type=script&setup=true&lang=js"

import "./StudentInfoPanel.vue?vue&type=style&index=0&id=2df74b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df74b1e"]])

export default __exports__